import _ from 'lodash';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { select, Store } from '@ngrx/store';

import { selectVirtualEventSlideSearch } from '../../features/data/data.selectors';
import { SlideCollection } from '../../models/slide-collection.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-virtual-event-slide-list',
  templateUrl: './virtual-event-slide-list.component.html',
  styleUrls: ['./virtual-event-slide-list.component.scss']
})
export class VirtualEventSlideListComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  @ViewChild(CdkVirtualScrollViewport)
  public viewport: CdkVirtualScrollViewport;

  @Input()
  public form: any = null;

  @Input()
  public index: number = 0;

  @Output() onEdit = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();

  public search$ = this.store.pipe(select(selectVirtualEventSlideSearch));
  public search: string = '';

  public collection = null;
  public options: UntypedFormArray = null;
  public list: any = null;

  public height: number = 83;
  public position: number = 0;
  public cdkDragStartedPosition = 0;
  public cdkDragEndedPosition = 0;

  public styles = { height: '83px' };
  
  constructor(
    private store: Store,
  ) { }

  ngOnInit(): void {
    this.options = this.form.get('slides') as UntypedFormArray;

    this.collection = new SlideCollection(this.options.controls);

    this.options.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(this.onOptionsValueChanges.bind(this));
    this.onOptionsValueChanges();
    
    this.search$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((search) => {
      this.search = search;
      this.collection.search = search;
      this.collection.applySearch();
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.viewport.scrollToIndex(this.index, "smooth");
    }, 500);
  }

  getSlideImageUrl(option) {
    return _.isEqual(option.imageUrl, '/images/blank_2x1.png') || _.isEqual(option.imageUrl, '') ?
      "/images/org_logo_default_v2.svg": option.imageUrl;
  }

  onCDKDragStarted(event) {
    this.cdkDragStartedPosition = this.position
  }

  onCDKDragEnded(event) {
    this.cdkDragEndedPosition = this.position
  }

  dropOption(event) {
    const { search , collection } = this;
    const { item: { data: { index: itemIndex } } }: any = event;

    const previousFoundIndex = _.findIndex(collection.found, option => {
      return option.index == itemIndex;
    });
    const currentFoundIndex = previousFoundIndex + (event.currentIndex - event.previousIndex);
    const currentIndex = collection.found[currentFoundIndex].index;

    moveItemInArray(this.options.controls, itemIndex, currentIndex);

    this.collection = new SlideCollection(this.options.controls);
    this.collection.search = search;
    this.collection.applySearch();
  }

  editSlide(value) {
  }

  removeSlide(index) {
    const sponsors = this.form.get('slides') as UntypedFormArray;
    sponsors.removeAt(index);
  }

  onOptionsValueChanges() {
    const { search } = this;
    this.collection = new SlideCollection(this.options.controls);
    this.collection.search = search;
    this.collection.applySearch();

    const foundLength = this.collection.found.length;
    const height = foundLength < 1 ? 83: foundLength * 83;
    this.height = height > 830 ? 830: height;
    this.styles = { height: `${this.height}px` };
  }

  moveTo(event: any) {
    const { search } = this;
    const position = parseInt(event.position);
    if(position >= 0 && this.options.controls.length > position) {
      moveItemInArray(this.options.controls, event.index, position);

      this.collection = new SlideCollection(this.options.controls);
      this.collection.search = search;
      this.collection.applySearch();
    }
  }
}
